<template>
  <v-layout style="padding: 20px">
    <v-flex xs12>
      <v-toolbar flat dense color="white">
        <v-toolbar-title class="dark-grey--text subheading">
          <b>Companies List</b>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          placeholder="Search"
          class="black--text"
          color="black"
        ></v-text-field>
        <v-spacer></v-spacer>
        <div class="text-xs-right">
          <IconAdd @clicked="addCompany" />
          <!-- <v-icon flat class="icon-color" @click ="$router.push('/company/add')">add</v-icon> -->
          <!-- <v-icon flat class="icon-color">print</v-icon>
                <v-icon flat class="icon-color">mdi-download</v-icon>
                <v-icon flat class="icon-color">mdi-export</v-icon>
                <v-icon flat class="icon-color">delete</v-icon> -->
        </div>
      </v-toolbar>
      <hr />
      <v-data-table
        :headers="headers"
        :items="companies"
        :search="search"
        select-all
        v-model="selected"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td width="5%">
            <v-checkbox
              v-model="props.selected"
              primary
              hide-details
            ></v-checkbox>
          </td>
          <td width="10%" class="text-xs-left">{{ props.item.id }}</td>
          <td width="20%" class="text-xs-left">
            {{ props.item.company_code }}
          </td>

          <td width="30%" class="text-xs-left">{{ props.item.name }}</td>

          <td
            width="20%"
            class="text-xs-left"
            :style="
              props.item.active == 1 ? 'font-weight:800' : 'font-weight:400'
            "
          >
            <img
              :src="
                props.item.active == 1
                  ? 'images/active.svg'
                  : 'images/inactive.svg'
              "
            />
            {{ props.item.active == 1 ? "Active" : "Inactive" }}
          </td>

          <td width="15%">
            <IconEdit @clicked="editCompany(props.item)" />
            <!-- <v-icon
              color="grey--text darken"
              small
              @click="editItem(props.item.id)"
              >fas fa-eye</v-icon
            > -->
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-flex>
    <v-dialog v-model="showDialog" max-width="800px">
      <!-- <CompanyAdd v-if="companyEdit" v-on:closeDialog="closeDialogue" /> -->
      <CompanyProfile
        v-if="companyEdit"
        :parameters="editItem"
        v-on:closeDialog="closeDialogue"
      />
    </v-dialog>
  </v-layout>
</template>
<script>
import CompanyModel from "@/api/service/CompanyService";
import IconAdd from "@/components/Icons/IconAdd";
//import CompanyAdd from "./add.vue";
import CompanyProfile from "./companyProfile";
import IconEdit from "@/components/Icons/IconEdit.vue";
import RoleModel from "@/api/service/RolesService";
export default {
  components: {
    IconAdd,
    // CompanyAdd,
    IconEdit,
    CompanyProfile,
  },
  data() {
    return {
      search: "",
      companyEdit: false,
      showDialog: false,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 100,
        sortBy: "id",
        totalItems: 0,
        rowsPerPageItems: [1, 2, 4, 8, 16],
      },
      selected: [],
      headers: [
        { text: "Id", value: "id" },
        { text: "Code", value: "company_code" },
        { text: "Name", value: "name" },

        { text: "Active", value: "active" },

        {},
      ],
      companies: [],
      role: {},
      editItem: {},
    };
  },
  created: function () {
    this.getRole();
    CompanyModel.findAll({})
      .then((response) => {
        this.setCompanies(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {},
  methods: {
    async getRole() {
      var $data = await RoleModel.getRoleForMyId();
      this.role = $data[0];
      if (this.role.user_type != "A") {
        this.$router.go(-1);
      }
    },
    addCompany() {
      this.editItem = {};
      this.showDialog = true;
      this.companyEdit = true;
    },
    closeDialogue() {
      this.showDialog = false;
      this.companyEdit = false;
    },
    setCompanies($company) {
      this.companies = $company;
    },
    editCompany($item) {
      this.editItem = $item;
      this.showDialog = true;
      this.companyEdit = true;
      // var $url = "/company/view?id=" + id;
      // this.$router.push($url);
    },
  },
};
</script>